// extracted by mini-css-extract-plugin
export default {"sectionTittle":"style_sectionTittle__MUR9l"};